
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatBraceletCode } from "@/utils/braceletUtils";

interface BraceletCodesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  braceletCodes: string[];
  congregationName: string;
  churchCode: string;
}

export function BraceletCodesDialog({
  open,
  onOpenChange,
  braceletCodes,
  congregationName,
  churchCode,
}: BraceletCodesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Bracelet Codes for {congregationName}
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-gray-500 mb-3">
            Church Code: <span className="font-mono font-medium">{churchCode}</span>
          </p>
          
          {braceletCodes.length === 0 ? (
            <p className="text-center py-6 text-gray-500">
              No bracelets registered for this church yet.
            </p>
          ) : (
            <div className="border rounded-md p-3 max-h-60 overflow-y-auto">
              <p className="font-medium mb-2">Registered Bracelets:</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {braceletCodes.map((code, index) => (
                  <div key={index} className="font-mono text-sm bg-gray-100 p-2 rounded">
                    {formatBraceletCode(code)}
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <div className="mt-4 pt-4 border-t">
            <p className="text-sm text-gray-600 mb-2">
              To add new bracelets to this church, go to the bracelet registration page and use this church code.
            </p>
            <Button 
              className="w-full"
              onClick={() => onOpenChange(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
